/**
 * Documentation links for the Omnyqra fork (Omnyqra/sim#41), see FORK.md.
 *
 * Blocks, settings and empty states link to Sim's docs under
 * {@link SIM_DOCS_ORIGIN}. With `NEXT_PUBLIC_DOCUMENTATION_URL` set, the origin
 * is swapped for that URL and the path kept; without it the link stays on
 * Sim's docs. Applied where links are rendered, so the hundreds of upstream
 * `docsLink` literals stay untouched.
 */
import { getEnv } from '@/lib/core/config/env'

const SIM_DOCS_ORIGIN = 'https://docs.sim.ai'

export function resolveDocsUrl(url: string): string
export function resolveDocsUrl(url: string | undefined): string | undefined
export function resolveDocsUrl(url: string | undefined): string | undefined {
  if (!url) return url
  const base = getEnv('NEXT_PUBLIC_DOCUMENTATION_URL')
  if (!base) return url
  if (url !== SIM_DOCS_ORIGIN && !url.startsWith(`${SIM_DOCS_ORIGIN}/`)) return url
  return `${base.replace(/\/+$/, '')}${url.slice(SIM_DOCS_ORIGIN.length)}`
}
